import {AfterViewInit, Component, ElementRef, HostListener, Input, OnChanges, OnDestroy, OnInit} from '@angular/core';
import {TranslateService} from "../../../services/multilingual/translate.service";
import * as echarts from 'echarts';

@Component({
  selector: 'truck-capacity-indication',
  templateUrl: './truck-capacity-indication.component.html',
  styleUrls: ['./truck-capacity-indication.component.scss']
})
export class TruckCapacityIndicationComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  visible: boolean=false;
  graphData=[];
  referenceLines=[];
  chart=null;
  trucksLabel: string;
  plantLabel: string;

  constructor(private TranslateService: TranslateService, private eRef: ElementRef) {}

  @Input() truckHours: any[]=[];

  ngOnInit(): void {
    this.trucksLabel=this.TranslateService.GetTranslation('production.truck')+
        this.TranslateService.GetTranslation('datetime.hours').toLowerCase();
    this.plantLabel=this.TranslateService.GetTranslation('company.plant');
  }
  ngAfterViewInit(): void {
    this.initChart();
  }
  ngOnChanges(): void {
    let trucks=this.TranslateService.GetTranslation('production.trucks').toLowerCase();
    let hour=this.TranslateService.GetTranslation('datetime.hour');

    this.graphData=[];
    this.referenceLines=[];
    for(let s=0; s<this.truckHours.length; s++) {
      let hours=[];

      // Calculate maximum value
      let max=0;
      for(let h=0; h<this.truckHours[s].truckHours.length; h++)
        max=Math.max(this.truckHours[s].truckHours[h].totalTrucks, max);

      for(let h=0; h<this.truckHours[s].truckHours.length; h++) {
        hours.push( {
          value: this.truckHours[s].truckHours[h].totalTrucks,
          percentage: Math.ceil(this.truckHours[s].truckHours[h].totalTrucks /max * 100 ),
          name: this.truckHours[s].truckHours[h].hour.toString(),
        });
      }

      let trucks_per_hour=Math.round(this.truckHours[s].plant.production_capacity / this.truckHours[s].average_truck_capacity);
      this.referenceLines.push({ name: this.truckHours[s].plant.code +
            ' (' + trucks_per_hour + ' ' + trucks + '/' + hour + ')', value: trucks_per_hour });
      this.graphData.push( { "name": this.truckHours[s].plant.code +
        ' (' + trucks_per_hour + ' ' + trucks + '/' + hour + ')', "series": hours });
    }
    this.drawGraph();
  }
  toggle() {
    this.visible=!this.visible;
    if(this.visible)
      setTimeout(() => {
        this.initChart();
        this.drawGraph();
        if(this.chart) this.chart.resize();
      });
  }
  initChart() {
    if(this.chart) return;
    const chartDom = document.getElementById('truck-capacity-chart');
    if(!chartDom) return;
    this.chart=echarts.init(chartDom, null, { renderer: 'canvas', useDirtyRect: false });
  }
  drawGraph() {
    if(!this.chart || !this.graphData.length) return;
    const hours = this.graphData[0].series.map((item: any) => item.name);
    const option = {
      tooltip: {
        trigger: 'axis'
      },
      legend: {
        top: 0,
        data: this.graphData.map((item: any) => item.name)
      },
      grid: {
        top: 35,
        left: 45,
        right: 25,
        bottom: 30
      },
      xAxis: {
        type: 'category',
        name: '',
        boundaryGap: false,
        data: hours
      },
      yAxis: {
        type: 'value',
        name: this.TranslateService.GetTranslation('production.trucks')
      },
      series: this.graphData.map((item: any) => ({
        name: item.name,
        type: 'line',
        data: item.series.map((serie: any) => serie.value),
        markLine: {
          symbol: 'none',
          label: {
            formatter: '{b}'
          },
          data: this.referenceLines
            .filter((line: any) => line.name===item.name)
            .map((line: any) => ({ name: line.name, yAxis: line.value }))
        }
      }))
    };
    this.chart.setOption(option, true);
  }
  @HostListener('document:keyup', ['$event'])
  onKeyUp(event: KeyboardEvent): void {
    if(event.key === 'Escape')
      this.toggle();
  }
  @HostListener("document:click", ['$event'])
  clickedOut(event: any) {
    if(!this.eRef.nativeElement.contains(event.target))
      this.visible=false;
  }
  @HostListener('window:resize')
  onResize() {
    if(this.chart) this.chart.resize();
  }
  ngOnDestroy() {
    if(this.chart) this.chart.dispose();
  }
}
